import { makeStyles } from '@material-ui/core/styles';
import { CreativeTemplatesEntities } from '../../../../../../constants';

export default (activeTabKey: CreativeTemplatesEntities) =>
  makeStyles((theme) => ({
    ItemRoot: {
      color: theme.palette.text.secondary,
      marginBottom: 16,
      padding: '8px 16px',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      ...(activeTabKey === CreativeTemplatesEntities.CTAs ? { flex: '0 32%', height: 'fit-content' } : {}),
      border: `1px solid ${theme.palette.divider}`,
      '& .MuiListItemIcon-root': {
        minWidth: 20
      },

      '& .ButtonGroup': {
        height: '30px',
        lineHeight: '20px',
        fontSize: '13px',
        visibility: 'hidden'
      },

      '&:hover .ButtonGroup': {
        visibility: 'visible;'
      }
    },
    Container: {
      width: '100%'
    },
    ListItemContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    ListItemText: {},
    HighlightedListItemText: {
      backgroundColor: theme.palette.primary.light,
      color: '#fff'
    },
    Score: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '7px',
      paddingLeft: 10,
      width: 70
    },
    ScoreContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6
    },
    LanguageIndicator: {
      fontSize: '10px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
      padding: '2px 4px',
      backgroundColor: theme.palette.grey[200],
      borderRadius: 3,
      lineHeight: 1.2,
      marginLeft: 8,
      marginRight: 8,
      flexShrink: 0
    },
    Button: {
      padding: 0,
      margin: 0,
      marginRight: '10px'
    },
    DeleteButton: {
      padding: 0,
      margin: 0,
      marginRight: '10px',
      color: 'rgb(220, 0, 78)'
    },
    LinearProgress: {
      width: 'calc(100% + 32px)',
      margin: '-8px -16px',
      marginBottom: 4
    },
    TextField: {
      '& .MuiFormHelperText-root': {
        textAlign: 'right'
      },

      '& textarea': {
        paddingRight: 30
      }
    },
    VariationScoreContainer: {
      position: 'absolute',
      right: 28,
      top: 18
    }
  }));
